import ApiV1, {GetApiV1Url} from "@/configs/axios/ApiV1";
import Axios, {CancelRequest, GetCancelToken} from "@/configs/axios/Axios";
import PermissionsV1 from "@/router/permissions/v1";
import {HasPermissionOrThrow} from "@/utils/permisshoinHelper";

export function GetReserveRoutes() {
    HasPermissionOrThrow(PermissionsV1["RESERVE.ROUTES"]);
    return Axios.get(GetApiV1Url(`reserve/routes/reserve`));
}

export function SendReserveStatsToOpenData(type) {
    HasPermissionOrThrow(PermissionsV1["STATISTICS.OPEN_DATA.RESERVE.SEND_STATS"]);
    CancelRequest(`statistics:open-data:reserve:${type}`);

    return ApiV1.get(`/statistics/open-data/reserve/${type}`, {
        signal: GetCancelToken(`statistics:open-data:reserve:${type}`),
    });
}
